export default __webpack_public_path__ + "static/media/THALL.64b1a157.png";